import { Outlet } from 'react-router';

const WithoutNavBar = () => <Outlet />;

export default WithoutNavBar;
